import { select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOpenPlatformIsProductLoading } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/products.selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

export namespace ProductsDisablerOpenPlatformProvider {
  export class IsLoading extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.pipe(select(getOpenPlatformIsProductLoading), takeUntil(this.ngDestroy));
    }
  }
}
